// extracted by mini-css-extract-plugin
export default {"container":"servicesSection_container__mvyoE","item":"servicesSection_item__negJA","active":"servicesSection_active__067eU"};